export default "__VITE_PUBLIC_ASSET__5a0c1c02__"